import Page from '@modules/login/pages/default';

export default Page;
